import ticketSent from 'assets/ticket-sent.png'
import { Dispatch, ReactElement, SetStateAction } from 'react'
import { useAppDispatch } from 'redux/hooks'
import { endChat } from 'redux/slices/message'
import { pageActions } from 'redux/slices/page'
import { Button, Flex, Text } from 'theme-ui'

export default function TicketSent({
  setIsGarryOpen,
}: {
  setIsGarryOpen: Dispatch<SetStateAction<boolean>>
}): ReactElement {
  const dispatch = useAppDispatch()

  return (
    <Flex
      data-testid="ticket-sent-view"
      sx={{
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Text
        sx={{
          color: 'white',
          fontSize: '28px',
          marginBottom: '46px',
          fontWeight: 'bold',
        }}
      >
        Ticket Sent!
      </Text>
      <img src={ticketSent} alt="" sx={{ mb: '50px' }} />
      <Flex
        sx={{
          color: 'white50',
          fontSize: '18px',
          marginBottom: '24px',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: '268px',
        }}
      >
        <Text sx={{ textAlign: 'center' }}>
          Thanks! Our support team will get back to you shortly.
        </Text>
      </Flex>
      <Button
        variant="neon"
        data-testid="splash-screen-button"
        onClick={() => {
          dispatch(endChat())
          dispatch(pageActions.clear())
          setIsGarryOpen(false)
        }}
        sx={{ width: '150px' }}
      >
        <Text sx={{ fontSize: '18px', color: 'black', fontWeight: 'bold' }}>Close</Text>
      </Button>
    </Flex>
  )
}
